'use client'

import dynamic from "next/dynamic"
import { StoreProfile } from "@/app/api/types"
import { useTranslations } from 'next-intl'

// Create a dynamic component that only loads on client-side
const MapClient = dynamic(() => import('./map-client'), {
  ssr: false,
  loading: () => {
    return (
      <div
        className="h-[200px] md:h-[400px] bg-gray-100 animate-pulse"
        aria-label="Loading map..." // TODO: translate later
      />
    )
  }
})

interface StoreMapProps {
  storeProfile: StoreProfile
}

// Create a wrapper component that passes props through
export const StoreMap = ({ storeProfile }: StoreMapProps) => {
  const t = useTranslations('Store.Map')

  return storeProfile.location_geo_json?.geometry.coordinates ? (
    <>
      <MapClient
        center={storeProfile.location_geo_json.geometry.coordinates}
        markers={[{
          position: storeProfile.location_geo_json.geometry.coordinates,
          popup: storeProfile.location_address,
        }]}
      />
    </>
  ) : (
    <div className="h-full w-full bg-muted flex items-center justify-center text-muted-foreground">
      {t('noLocation')}
    </div>
  )
}
